import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import {
    RaceSummaryAntePostBox,
    RunnerCellAntePost,
} from 'src/domains/sportsbook/webview/components/raceSummary/raceSummaryRowSport/AntePostAndSpecials/AntePostAndSepcials.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface AntePostAndSpecialsPropsType {
    className?: string;
    dataTest?: string;
    selectionId: SelectionId;
    winner?: React.ReactNode;
}

export const AntePostAndSpecials = observer('AntePostAndSpecials', (props: AntePostAndSpecialsPropsType) => {
    const { className, dataTest, selectionId, winner } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const selectionModel = selectionId.getModel();
    if (selectionModel === null) {
        return null;
    }

    const marketModel = selectionModel.getMarket();
    if (marketModel === null) {
        return null;
    }

    const runnerName = selectionModel.name;

    return (
        <RaceSummaryAntePostBox
            className={className}
            data-test={dataTest}
            variant={configState.componentVariants.sportsbookVariant}
        >
            {runnerName !== '' && <RunnerCellAntePost>{runnerName}</RunnerCellAntePost>}
            {winner}
        </RaceSummaryAntePostBox>
    );
});
